import axios from 'axios';

export const getDictionary = async solution => {
  let numberString;

  switch (solution.length) {
    case 5:
      numberString = 'five';
      break;
    case 6:
      numberString = 'six';
      break;
    case 7:
      numberString = 'seven';
      break;
    default:
      numberString = 'eight';
  }
  
  return (
    await import(
      `../constants/validGuesses/validGuesses_${numberString}`
    ))[`VALID_GUESSES_${numberString.toUpperCase()}`];
};

export const getGameNumber = date => {
  const epoch = new Date(2023, 3, 10).valueOf();
  // Divide by ms per day to get number of days since epoch
  return Math.floor((date - epoch) / 86400000);
};

export const getWordOfTheDay = async (id) => {
  const url = `/api/bardle/word-of-the-day?id=${id}`;
  return axios.get(url).then(({ data }) => {
    const solutionData = {};
    Object.keys(data).forEach(key => {
      solutionData[key.toLowerCase()] = data[key];
    });

    return solutionData;
  });
};